<template>
  <el-container v-if="!loading" class="home">
    <!-- 头部 -->
    <el-header class="el-head">
      <div class="logo">
        <img
          :src="userInfo.schoolLogo ? userInfo.schoolLogo : 'icon/yxlogo.png'"
        />
        <!-- <img src="../assets/image/other/logo.png" style="margin-right:10px" />
				<img src="../assets/image/login/tit.png" style="margin-right:50px" />-->
      </div>
      <div class="header-menu">
        <swiper
          style="
            width: 100%;
            height: 100%;
            padding: 0 24px;
            box-sizing: border-box;
          "
          :options="swiperOptions"
        >
          <swiper-slide
            class="nav"
            v-for="i in menuInfoList"
            :key="i.menuCode"
            :index="i.menuCode"
          >
            <router-link class="nav-item" :to="{ name: i.menuCode }">{{
              i.menuName
            }}</router-link>
          </swiper-slide>
          <!-- <div class="swiper-button-prev" slot="button-prev"></div>
					<div class="swiper-button-next" slot="button-next"></div>-->
        </swiper>
      </div>
      <div class="ai-img-box">
        <el-tooltip
          v-if="power(userInfo.menuInfoList, 'netDisk')"
          content="网盘"
          placement="bottom"
        >
          <img
            src="icon/logo_net.png"
            class="ai-img"
            alt="网盘"
            @click="onGoToNetDisk"
          />
        </el-tooltip>
        <el-tooltip content="AI助手" placement="bottom">
          <img
            src="icon/logo.png"
            class="ai-img"
            alt="AI助手"
            @click="onGoToAI"
          />
        </el-tooltip>
      </div>

      <el-dropdown @command="handleCommand">
        <div class="user" @click="goUserCenter">
          <img :src="userInfo.userLogo ? userInfo.userLogo : userLogo" alt />
          <span class="tearch-name">{{
            userInfo ? userInfo.userName : ''
          }}</span>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="isAdmin" command="a">
            <span>系统管理</span>
          </el-dropdown-item>
          <el-dropdown-item command="b">
            <span>退 出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-header>
    <!-- 导航栏 和 内容 -->
    <el-main style="position: relative">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>

<script>
import { power } from '@/utils/index.js'
import { mapGetters, mapState } from 'vuex'
import { conf } from '../config'
export default {
  computed: {
    ...mapGetters(['menuInfoList']),
    ...mapState(['userInfo', 'loading']),
    active() {
      let pathArray = this.$route.path.split('/')
      if (pathArray.length > 0) {
        let path = ''
        pathArray.forEach((p) => {
          if (
            this.menuInfoList.some((s) => {
              return p == s.menuUrl
            })
          ) {
            path = p
          }
        })
        return path
      } else {
        return 'home'
      }
    },
    isAdmin() {
      return this.userInfo.roleCodes.includes('admin')
    }
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 'auto',
        centeredSlides: false,
        observe: true
        // navigation: {
        // 	nextEl: ".swiper-button-next",
        // 	prevEl: ".swiper-button-prev"
        // }
      },
      userLogo: require('@/assets/image/other/man_teacher.png')
    }
  },
  created() {
    this.init()
  },
  methods: {
    power,
    onGoToAI() {
      window.open(
        `http://oauth.xueduoduo.com/chat/?userId=${this.userInfo.userId}&projectCode=xdd-tpdp`
      )
    },
    onGoToNetDisk() {
      window.open(
        `http://hyx.xueduoduo.com/duoduo-net-disk/#/?userId=${this.userInfo.userId}&projectCode=xdd-tpdp`
      )
    },
    handleCommand(command) {
      if (command == 'a') {
        this.gotoBack()
      } else if (command == 'b') {
        this.logout()
      }
    },
    gotoBack() {
      const { host, pathname } = window.location
      const href = `${conf.backManagerUrl}?origin=${host}${pathname}&router=${conf.router}`
      window.open(href)
    },
    onNavSelected(index, indexPath) {
      if (index == 'userCenter') {
        this.$router.push({ name: 'plan' })
      } else {
        this.$router.push({ name: index })
      }
    },
    async init() {
      this.$store.commit('loadingStart')
      await this.$store.dispatch('getUserInfo')
      await this.$store.dispatch('getSchoolList')
      await this.$store.dispatch('getCurrentSemester')
      this.$store.commit('loadingFinish')
    },
    logout() {
      this.$confirm('亲, 你确认要进行退出么?', '温馨提示', {
        type: 'warning'
        // confirmButtonClass: "logout-btn"
      })
        .then(() => {
          this.$axios
            .get('/oauth/logout')
            .then((res) => {
              if (res.resultCode === 200) {
                this.$message.success('恭喜, 退出成功')
                localStorage.removeItem('newAutoLogin')
                this.$router.push('/login')
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                  duration: 2000,
                  offset: 150
                })
              }
            })
            .catch((err) => {
              console.log(err)
            })
        })
        .catch((err) => {
          console.log(err)
        })
    },
    goUserCenter() {
      this.$router.push({ name: 'plan' })
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
.home {
  height: 100vh;
  .el-header {
    background-color: #fff;
    display: flex;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    z-index: 20;
    .logo {
      img {
        height: 40px;
        margin-top: 12px;
      }
    }
    .header-menu {
      flex: 1;
      font-family: pfrgl;
      font-size: 18px;
      color: #666666;
      line-height: 60px;
      box-sizing: border-box;
      .swiper-button-prev {
        background: rgb(255, 255, 255);
        left: 0 !important;
      }
      .swiper-button-next {
        background: rgb(255, 255, 255);
        right: 0 !important;
      }
      .swiper-button-disabled {
        opacity: 0 !important;
      }
      .nav {
        padding: 0 14px;
        width: auto;
        .nav-item {
          display: block;
          height: 100%;
          position: relative;
          &:after {
            display: block;
            content: '';
            height: 4px;
            width: 100%;
            bottom: 8px;
            position: absolute;
          }
        }
        .router-link-active {
          color: #1890ff;
          &::after {
            background: linear-gradient(90deg, #35c3ff 0%, #1890ff 100%);
          }
        }
      }
    }
    .el-dropdown {
      border: 1px solid #fff;
    }
    .ai-img-box {
      height: 100%;
      margin-right: 20px;
      display: flex;
      align-items: center;

      .ai-img {
        width: 35px;
        cursor: pointer;
        height: 35px;
        position: relative;
        top: 2px;
        margin-right: 10px;
      }
    }

    .user {
      cursor: pointer;
      height: 58px;
      font-size: 15px;
      text-align: left;
      line-height: 58px;
      color: #666;
      border: 1px solid #fff;

      .tearch-name {
        margin-right: 5px;
      }
      img {
        margin-right: 8px;
        margin-bottom: 3px;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        vertical-align: middle;
      }
    }
  }
}
</style>
